
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_1ro4b_13",
  "arrow-outer": "awsui_arrow-outer_xjuzf_1ro4b_17",
  "arrow-inner": "awsui_arrow-inner_xjuzf_1ro4b_17",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_1ro4b_61",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_1ro4b_61",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_1ro4b_64",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_1ro4b_64",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_1ro4b_67",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_1ro4b_67",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_1ro4b_67",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_1ro4b_67",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_1ro4b_70",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_1ro4b_70",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_1ro4b_70",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_1ro4b_70",
  "arrow-variant-info": "awsui_arrow-variant-info_xjuzf_1ro4b_74",
  "body": "awsui_body_xjuzf_1ro4b_85",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_1ro4b_121",
  "body-variant-chart": "awsui_body-variant-chart_xjuzf_1ro4b_124",
  "has-dismiss": "awsui_has-dismiss_xjuzf_1ro4b_129",
  "dismiss": "awsui_dismiss_xjuzf_1ro4b_134",
  "dismiss-control": "awsui_dismiss-control_xjuzf_1ro4b_142",
  "header-row": "awsui_header-row_xjuzf_1ro4b_146",
  "header": "awsui_header_xjuzf_1ro4b_146",
  "content": "awsui_content_xjuzf_1ro4b_175",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_1ro4b_184",
  "container": "awsui_container_xjuzf_1ro4b_192",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_1ro4b_203",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_1ro4b_203",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_1ro4b_203",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_1ro4b_208",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_1ro4b_208",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_1ro4b_208",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_1ro4b_213",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_1ro4b_213",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_1ro4b_218",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_1ro4b_218",
  "container-body": "awsui_container-body_xjuzf_1ro4b_224",
  "container-body-variant-annotation": "awsui_container-body-variant-annotation_xjuzf_1ro4b_264",
  "container-body-size-small": "awsui_container-body-size-small_xjuzf_1ro4b_269",
  "fixed-width": "awsui_fixed-width_xjuzf_1ro4b_272",
  "container-body-size-medium": "awsui_container-body-size-medium_xjuzf_1ro4b_276",
  "container-body-size-large": "awsui_container-body-size-large_xjuzf_1ro4b_283",
  "container-arrow": "awsui_container-arrow_xjuzf_1ro4b_203",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_1ro4b_333",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_1ro4b_1",
  "refresh": "awsui_refresh_xjuzf_1ro4b_387",
  "awsui-popover-settle-down": "awsui_awsui-popover-settle-down_xjuzf_1ro4b_1",
  "awsui-popover-settle-up": "awsui_awsui-popover-settle-up_xjuzf_1ro4b_1",
  "awsui-popover-settle-end": "awsui_awsui-popover-settle-end_xjuzf_1ro4b_1",
  "awsui-popover-settle-start": "awsui_awsui-popover-settle-start_xjuzf_1ro4b_1",
  "root": "awsui_root_xjuzf_1ro4b_497",
  "no-wrap": "awsui_no-wrap_xjuzf_1ro4b_529",
  "trigger-type-text-inline": "awsui_trigger-type-text-inline_xjuzf_1ro4b_532",
  "overflow-ellipsis": "awsui_overflow-ellipsis_xjuzf_1ro4b_532",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_1ro4b_532",
  "root-filtering-token": "awsui_root-filtering-token_xjuzf_1ro4b_554",
  "trigger": "awsui_trigger_xjuzf_1ro4b_532",
  "in-inline-token": "awsui_in-inline-token_xjuzf_1ro4b_596",
  "trigger-type-filtering-token": "awsui_trigger-type-filtering-token_xjuzf_1ro4b_644",
  "popover-inline-content": "awsui_popover-inline-content_xjuzf_1ro4b_648",
  "hover-area": "awsui_hover-area_xjuzf_1ro4b_652"
};
  